import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Token, post } from "../../../Script/Session";
import NavigationBar from "../../../components/Navigationbar/Navigationbar";
import Sidebar from "../../../components/Sidebar/Sidebar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Fbeschreibung.css";

const Fbeschreibung = () => {
    const [wit, setwith] = useState("90.5%");



    const navigate = useNavigate();
    useEffect(() => {
        const fetchVereinData = async () => {
            const body = {
                token: Token.get(),
                action: "getnames",
            };

            try {
                let response = await post(body, "/fbeschreibungen");

                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                setData(JSON.parse(response));
                console.log(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchVereinData();
    }, [navigate]);

    function fetchdesc(n) {
        const body = {
            token: Token.get(),
            action: "getdesc",
            "name": n,
        };
        console.log(body);
        let response = post(body, "/fbeschreibungen");
        setinhalt(response);
    }

    const [data, setData] = useState([]);
    const [inhalt, setinhalt] = useState("Bitte Wählen...");
    const [cur, setcur] = useState(null);
    return (
        <>
         <head><title>Verein || Funktions Beschreibungen</title></head>
         <div style={{width:wit, position: "fixed",flexDirection: "row" ,top: "0", right: "0", backgroundColor: "white", height: "100vh", display: "flex", }}>
          <div style={{backgroundColor: "#f2f2f2", width: "15%", height: "100vh", display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div style={{height: "4%", width: "100%", flexDirection: "column", justifyContent: "center", display: "flex"}}>
                <p style={{color: "gray", fontSize: "20px", marginTop: "13%", marginLeft: "5%"}}>Funktionen</p>
                
            </div>
            <div style={{width: "95%", height: "1px", backgroundColor: "gray", marginTop: "6%"}}></div>
            <ul style={{overflowY: "auto",listStyle: "none", height: "94.5%", width: "100%", backgroundColor: "transparent", padding: "0px", display: "flex",alignItems: "center", flexDirection: "column", marginBottom: "0px"}}>
                {data.value && data.value.map(item =>
                <>
                <div 
                onClick={() => {fetchdesc(item.name); setcur(item.name)}}
                onMouseEnter={(e) => {e.target.style.backgroundColor = "#e4e2e2"; e.target.style.cursor = "pointer";}}
                onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                style={{height: "5%", marginBottom: "5px", backgroundColor: "transparent", width: "95%"}}>
                    <p style={{marginLeft: "5%", color: "gray"}}>{item.name}</p>
                </div>
                   
                </>
                )}

            </ul>

          </div>
          <div style={{ height: "100vh", width: "85%"}}>
            <div style={{color: "gray", fontSize: "20px",backgroundColor: "#f5f5f5", width: "100%", height: "6%", flexDirection: "column", display: "flex", justifyContent: "center"}}>
                <a style={{marginLeft: "1%"}}>{cur}</a>
            </div>
          <ReactQuill value={inhalt} readOnly={true} theme="bubble" style={{ display: "flex", width: "100%", height: "94%", fontSize: "1.2rem", backgroundColor: "#fafafa" }} />


          </div>





        </div>
        <div><NavigationBar state={"verein"} back={true} /></div>
            <Sidebar />
        </>
    )
}

export default Fbeschreibung;